<div class="updater-content">
  <span class="title-text">{{ 'UPDATER.MESSAGE' | translate }}</span>
  <button app-flat-button class="update-btn" color="primary" size="small" type="button" (click)="update()">
    {{ 'UPDATER.BUTTON' | translate }}
  </button>
  <button mat-icon-button class="close-btn" type="button" (click)="close()">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
